import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider";
import { authRoutes } from "../../../features/auth/config/authRoutes";
import RouteFallback from "../fallback/RouteFallback";

export default function ProtectedRoute() {
  const location = useLocation();
  const { isAuthenticated, status, user } = useAuth();

  if (status === "booting") return <RouteFallback />;

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const isEmailVerified = String(user?.emailVerified).toLowerCase() === "true";
  const requiresAccountSelection =
    isEmailVerified &&
    (Boolean(user?.accountSelectionRequired) || !user?.accountId);

  if (
    requiresAccountSelection &&
    location.pathname !== authRoutes.selectAccount
  ) {
    return <Navigate to={authRoutes.selectAccount} replace />;
  }

  return <Outlet />;
}
